import { Component, forwardRef, Injector, OnInit } from '@angular/core';
import { DynamicComponentBase, IDynamicComponentConfig, RenderComponentBase } from '../../../dynamic-component';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-r-checkbox',
  templateUrl: './r-checkbox.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RCheckboxComponent),
      multi: true
    }
  ]
})
export class RCheckboxComponent extends RenderComponentBase {
  static KEY = 'r-d-checkbox';

  constructor(injector: Injector) {
    super(injector);
  }

  configChange(config: IDynamicComponentConfig) {
    if (!Array.isArray(config.dataSource)) {
      config.dataSource = [
        {
          value: '1',
          label: '选项1'
        },
        {
          value: '2',
          label: '选项2'
        },
        {
          value: '3',
          label: '选项3'
        }
      ];
    }

    if (Array.isArray(config.dataSource) && config.value) {
      config.dataSource.map(data => {
        let valueArr = config.value.split(',');
        if (valueArr.includes(data.value)) {
          data.checked = true;
        }
      });
    }
  }
}
